var _defs, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path3, _line9, _line10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveDailyMgmt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.4 136.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:6px;}.cls-1,.cls-2{fill:none;stroke:#48a8fc;stroke-miterlimit:10;}.cls-3{fill:#061f35;}.cls-2{stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m26,0h84.4c14.4,0,26,11.6,26,26v84.4c0,14.4-11.6,26-26,26H26c-14.4,0-26-11.6-26-26V26C0,11.6,11.6,0,26,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.4,83.6c6.1-7.3,5.1-18.1-2.2-24.2s-18.1-5.1-24.2,2.2c-6.1,7.3-5.1,18.1,2.2,24.2,7.3,6.1,18.1,5.1,24.2-2.2Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.5,
    y1: 71.7,
    x2: 54.9,
    y2: 60.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.8,
    y1: 42.9,
    x2: 47.8,
    y2: 37.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 85.6,
    y1: 42.9,
    x2: 88.6,
    y2: 37.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 33.5,
    y1: 73.1,
    x2: 27.4,
    y2: 73.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 109,
    y1: 73.1,
    x2: 102.9,
    y2: 73.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.3,
    y1: 42.3,
    x2: 68.3,
    y2: 27.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.4,
    y1: 56.9,
    x2: 27.4,
    y2: 48.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.2,
    y1: 56.9,
    x2: 109.2,
    y2: 48.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.3,91.9s-11.1-18.5-1.7-35.4,28.6-16.4,28.6-16.4c0,0,20.1.1,28.5,16.5,8.4,16.5,1.8,29.1-1.6,35.3"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.2,
    y1: 88.7,
    x2: 107.4,
    y2: 95.8
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.4,
    y1: 88.7,
    x2: 29.2,
    y2: 95.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDailyMgmt);
export default __webpack_public_path__ + "static/media/active_daily_mgmt.89a8a1e63727d14c8ef0a258deb9fbc6.svg";
export { ForwardRef as ReactComponent };